<script>
import AccordionList from '@/components/shared/AccordionList.vue';

export default {
  name: 'HomeAccordion',
  components: { AccordionList },
  data: () => ({
    items: [
      {
        title: 'Created especially for new & classic Porsche vehicles 1981+',
        image: 'accordion_01.jpg',
        content: `
          <h3>Bring your new & classic Porsche vehicles.</h3>
          <p>
            If your heart skips a beat every time you slide behind the wheel
             of your Porsche, we get it!
          </p>
          <p>
            Your investment is emotional. Discover built-in features designed
            by Porsche experts to protect and preserve your vehicle.
          </p>
        `,
        order: 0
      },
      {
        title: 'Coverage for your family members & other makes',
        image: 'accordion_02.jpg',
        content: `
          <h3>For your family & other vehicle makes, too.</h3>
          <p>
            Insurance should be easy.
          </p>
          <p>
            We deliver the most complete coverage in one package, not only
            for your Porsche, but for the other vehicles in your driveway—
            and their drivers.
          </p>
        `,
        order: 1
      },
      {
        title: 'Pay-per-mile rates & Unlimited mileage options',
        image: 'accordion_03.jpg',
        content: `
          <h3>
            <p style="margin:0;">Pay-per-mile rates & Unlimited mileage options:</p>
            <p style="margin:0;">No two drivers are exactly alike.</p>
          </h3>
          <p>
            Created to fit the lifestyles of those who do not put in as
            much road time—customers who opt for our Pay-per-mile pricing
            will receive a modest monthly base charge, plus a charge for
            the actual miles driven.
          </p>
          <p>
            Unlimited mileage pricing gives customers a low, steady single rate,
            regardless of how far you drive.
          </p>
        `,
        order: 0
      },
      {
        title: 'Agreed Value Coverage (even custom parts & accessories)',
        image: 'accordion_04.jpg',
        content: `
          <h3>
            Agreed Value: Rest easy & drive on.
          </h3>
          <p>
            At the time you sign up, you have the power to establish the
            fair value of your vehicle if a total loss occurs. You can
            expect to be reimbursed in full, including the cost of any
            custom accessories and parts installed on your covered vehicle.
          </p>
        `,
        order: 1
      },
      {
        title: 'Porsche approved collision center priority status',
        image: 'accordion_05.jpg',
        content: `
          <h3>
            Porsche Approved Collision Centers: Skip the line.
          </h3>
          <p>
            Did you know that Porsche Auto Insurance customers receive
            priority service at every Porsche Approved Collision Center?
          </p>
          <p>
            Accidents happen. Our single objective is to get you and your
            vehicle back on the road, faster.
          </p>
        `,
        order: 0
      },
      {
        title: 'Always Porsche Genuine Parts',
        image: 'accordion_06.jpg',
        content: `
          <h3>
            Porsche Genuine Parts: No substitutions.
          </h3>
          <p>
            Porsche drivers know the real value of originality, quality,
            and performance in their vehicles. Unlike most regular insurance
            companies, Porsche Auto Insurance automatically approves
            Porsche Genuine Parts with every claim.
          </p>
        `,
        order: 1
      }
    ]
  })
};
</script>

<template>
  <section class="details-section">
    <div class="container">
      <h1 class="title">
        Meet the ideal road partner for you & your Porsche.
      </h1>
      <p>
        Do you value real expertise from Porsche specialists who understand what
        your vehicle means to you? Porsche Auto Insurance was created to protect
        your automotive investment with coverage that exceeds your highest
        expectations. Join us today and gain the confidence of knowing you chose
        wisely, yet again.
      </p>
      <AccordionList :data="items" />
    </div>
  </section>
</template>

<style scoped lang="scss">
section.details-section {
  background-color: $base;
  margin: 1rem 0;
  div.container {
    padding-top: $--pcom-spacing-large;
    padding-bottom: $--pcom-spacing-x-large;
  }
}
</style>
